export class SendingChannelType {
  static Portal = 1;
  static Email = 2;
  static Sms = 3;
}
